import { render, staticRenderFns } from "./RoomPriceSystem.vue?vue&type=template&id=d3740202&scoped=true&"
import script from "./RoomPriceSystem.vue?vue&type=script&lang=js&"
export * from "./RoomPriceSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3740202",
  null
  
)

export default component.exports